module.exports = __webpack_public_path__ + "static/elephantbathhamper-5704011e515f30f09b5cf27987d6a3b0.jpeg";